import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Itinerante } from "../../../../services/Itinerante";
import { IItineranteListProps } from "../../../../types/itinerante";

export const useItineranteLista = (props: IItineranteListProps) => {
  const query = useQuery({
    queryKey: ["itinerante-lista", props],
    queryFn: () => Itinerante.list(props),
    select: (response) => response.data,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
